/* Granatelli filter-pill exclusive open
   Only one selector inside .gm-filter-bar can be open at a time. This covers
   both:
     - Filter pills (<details class="facets__disclosure">)
     - Sort dropdown (native <select>)

   Behavior:
     - Opening any filter pill → close every other pill + blur the sort select
       (which closes its native dropdown).
     - Mousedown/focus on the sort select → close every open filter pill before
       the native dropdown appears.
     - Click anywhere outside the bar → close every open pill.

   Event delegation uses capture phase because <details> "toggle" does not bubble.
*/
(function () {
  'use strict';

  function closeAllPills(bar, except) {
    bar.querySelectorAll('.facets__disclosure[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  function blurSort(bar) {
    var sortSelect = bar.querySelector('select[name="sort_by"], .facet-filters__sort');
    if (sortSelect && typeof sortSelect.blur === 'function') sortSelect.blur();
  }

  function init() {
    var bar = document.querySelector('.gm-filter-bar');
    if (!bar || bar.__gmPillsExclusiveInit) return;
    bar.__gmPillsExclusiveInit = true;

    /* When a pill opens → close every other pill AND close the sort dropdown */
    bar.addEventListener('toggle', function (event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('.facets__disclosure')) return;
      if (!target.open) return;
      closeAllPills(bar, target);
      blurSort(bar);
    }, true);

    /* When user clicks/focuses the sort select → close every open filter pill
       BEFORE the native dropdown opens (mousedown fires first). */
    var sortSelect = bar.querySelector('select[name="sort_by"], .facet-filters__sort');
    if (sortSelect) {
      sortSelect.addEventListener('mousedown', function () { closeAllPills(bar); });
      sortSelect.addEventListener('focus', function () { closeAllPills(bar); });
      sortSelect.addEventListener('keydown', function (event) {
        /* Space / Enter / ArrowDown opens the native dropdown — close pills */
        if (event.key === ' ' || event.key === 'Enter' || event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          closeAllPills(bar);
        }
      });
    }

    /* Click anywhere outside the bar → close every open pill */
    document.addEventListener('click', function (event) {
      if (bar.contains(event.target)) return;
      closeAllPills(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
